import SenderAvatar from "@/components/mailsList/SenderAvatar";
import AgendaItemAttendee from "@/domain/entities/agenda/AgendaItemAttendee";
import AgendaItemOrganizer from "@/domain/entities/agenda/AgendaItemOrganizer";
import { ResponseStatus } from "@/domain/entities/agenda/AgendaItemResponseStatus";
import EmailUser from "@/domain/entities/emails/EmailUser";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

type EventAttendeeProps = {
    attendee: AgendaItemAttendee;
    organizer?: AgendaItemOrganizer;
};

const EventAttendee = ({ attendee, organizer }: EventAttendeeProps) => {
    const { t } = useTranslation();
    const userIsOrganizer =
        organizer?.emailAddress?.address === attendee.emailAddress?.address;

    return (
        <div className="flex items-center gap-2 pl-6">
            <SenderAvatar
                user={
                    new EmailUser({
                        name: attendee.emailAddress.name,
                        email: attendee.emailAddress.address,
                        avatarUrl: null,
                    })
                }
            />
            <div>
                <p>
                    {attendee.emailAddress.name}
                    {attendee.status && !userIsOrganizer && " - "}
                    {attendee.status && !userIsOrganizer && (
                        <span
                            className={cn(
                                attendee.status?.response ===
                                    ResponseStatus.None && "italic",
                            )}
                        >
                            <span className="opacity-70">
                                {t(
                                    `dashboard.widgets.calendar.event.responseStatus.${attendee.status.response}`,
                                )}
                            </span>
                        </span>
                    )}
                </p>
                {userIsOrganizer && (
                    <p className="text-xs">
                        {t("dashboard.widgets.calendar.event.organizer")}
                    </p>
                )}
            </div>
        </div>
    );
};

export default EventAttendee;
